import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useFetchCampaigns = (filters = {}) => {
  const {
    data: { campaigns },
    isFetching,
  } = useQuery(
    ['campaigns', filters],
    () => get('/api/client_admin/campaigns', filters),
    {
      refetchOnWindowFocus: false,
      initialData: {
        campaigns: [],
      },
    },
  );

  return {
    campaigns,
    isFetching,
  };
};

export const useFetchPaginatedCampaigns = ({
  page,
  itemsPerPage,
  showAll,
  campaignStatus,
  statusFilters,
  sortBy,
  sortDirection,
}) => {
  const params = {
    page,
    limit: itemsPerPage,
    show_all: showAll,
    sort_by: sortBy,
    sort_direction: sortDirection,
  };

  // Use by_statuses filter if provided, otherwise fall back to campaignStatus
  if (statusFilters && statusFilters.length > 0) {
    params.by_statuses = statusFilters;
  } else if (campaignStatus) {
    params[campaignStatus] = true;
  }

  const { data = { campaigns: [] }, isFetching, isLoading } = useQuery(
    ['campaigns', params],
    () => get('/api/client_admin/campaigns', params),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  return {
    data,
    isFetching,
    isLoading,
  };
};
